<template>
    <div class="user-v2" :class="{ selected: isSelectedUser && isSelectedUser(user) }" @click="onClickUser">
        <div class="flex-row items-center">
            <div class="photo-wrapper flex-wrap">
                <PhotoAndLastSeen :profile="user.photo_url" :lastSignInAt="user.last_sign_in_at" :userId="user.id" />
            </div>
            <div class="flex-fill">
                <div class="info">
                    <div class="upper flex-row m-b-4">
                        <div class="flex-row items-center">
                            <div class="name flex-wrap m-r-4">{{ user.profile.nickname }}</div>
                            <span class="basic">
                                <span>({{ user.profile.birthday | asAge }}세</span>
                                <span class="divider" v-html="'ㅣ'" />
                                <span>{{ user.profile.height }}cm)</span>
                            </span>
                        </div>
                    </div>
                    <div class="flex-row">
                        <div class="region flex-wrap m-r-4">{{ user.profile.region_name }}</div>
                        <Distance :distance="user.$$distance" />
                    </div>

                    <div class="job flex-row">
                        <div class="flex-wrap" v-html="user.profile.job_name" />
                        <div class="divider flex-wrap" v-html="'ㅣ'" />
                        <div class="flex-wrap" v-if="company" v-html="company" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'UserV2',
    props: ['user', 'isSelectedUser'],
    methods: {
        async onClickUser(event) {
            await this.$store.dispatch('loadIntroducingUser', this.user.id)
            // this.$store.commit('setShowFriendsFilter', false)
        },
    },
    computed: {
        company() {
            return this.$options.filters.company(this.user.profile)
        },
    },
}
</script>
